var _style, _g, _g2, _g3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeePortalWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Employee_Portal_-_White",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 160",
    style: {
      enableBackground: "new 0 0 144 160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.35;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{opacity:0.75;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.7,34.8c-3.9,2.2-7,7.6-7,12.1v66.2c0,4.5,3.1,9.9,7,12.1L65,158.3c3.9,2.2,10.1,2.2,14,0l57.3-33.1 c3.9-2.2,7-7.6,7-12.1V46.9c0-4.5-3.1-9.8-7-12.1L79,1.7c-3.9-2.2-10.1-2.2-14,0L7.7,34.8L7.7,34.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.4,27c-4.5,2.5-8.2,9-8.2,14.2V119c0,5.2,3.7,11.6,8.2,14.2l22.8,13.1c4.5,2.5,8.2,4.8,8.2,4.8 s3.7-2.1,8.3-4.8l55.7-31.9c4.5-2.5,8.4-8.9,8.4-14.2l0.6-40.9c0-5.2-3.6-11.6-8.1-14.2L61.3,13.5c-4.5-2.5-8.2-4.6-8.2-4.6 s-3.7,2.1-8.2,4.8L21.4,27L21.4,27z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.7,35c-3.9,2.2-7,7.6-7,12.1v66.2c0,4.5,3.1,9.9,7,12.1L34,140.4h0.2l62.1-39.2c3.7-2.4,6.9-7.9,6.9-12.4 l0.3-19c0-4.5-3-10-6.7-12.2L41.3,23.8c-3.7-2.4-6.9-4.2-6.9-4.2s-3.1,1.8-7,4L7.7,35L7.7,35z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.9,35.8c-2.8,1.6-5.2,5.8-5.2,9.1v70.3c0,3.3,2.4,7.5,5.2,9.1l11.3,6.7L41,116.2l31.8-20.4 c2.8-1.8,5.1-6.1,5.2-9.4l0.2-14.3c0-3.3-2.2-7.5-5.1-9.2l-50-30.7c-2.8-1.8-5.2-3.1-5.2-3.1s-2.4,1.3-5.2,3.1L5.9,35.8L5.9,35.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeePortalWhite);
export default __webpack_public_path__ + "static/media/EmployeePortal_White.8a7b3af8803be6ebd9c9ab7566609da1.svg";
export { ForwardRef as ReactComponent };